<template>
  <div class="flex items-center justify-between mt-3 w-fit px-2 py-1 gap-2">
    <a :href="`/${item.product.slug}`">
      <VImg
        :src="item.product.media"
        :hover="item.product.hoverMedia"
        alt="Produit"
        class="w-32 object-contain"
      />
    </a>
    <div class="flex-1 sm:pl-6 pl-2">
      <div class="flex items-center gap-x-2 justify-between">
        <p class="font-medium text-sm">
          {{ item.product.name }}
        </p>
      </div>
      <div class="text-sm font-semibold text-red-500">
        {{ trans.get('miliboo.cart.item-out-of-stock') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue';
import VImg from '../../../components/common/VImg.vue';

const trans = inject('translate');

defineProps({
  item: {
    type: Object,
    required: true,
  },
});
</script>
